// extracted by mini-css-extract-plugin
var _1 = "TableCellControl-module__captureBackgroundClick--s6pbC";
export { _1 as "captureBackgroundClick" }
